// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1hHEe","buttons":"PendingPaymentAlert_buttons__2RmPp"};